import type { CrmNoteType } from '@plato/data/prisma';
import { CalendarIcon, NotepadTextIcon, PhoneIcon } from 'lucide-react';
import React from 'react';
import { RadioGroup, RadioGroupItem } from '../../../components/ui/radio-group.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import { getNoteTypeLabel } from '../utils/get-note-type-label';

export type NoteTypeSelectorProps = {
    value: CrmNoteType;
    onChange: (value: CrmNoteType) => void;
};

type NoteTypeOption = {
    value: CrmNoteType;
    icon: React.ComponentType<{ className?: string }>;
};

const noteTypeOptions: NoteTypeOption[] = [
    {
        value: 'VISIT',
        icon: CalendarIcon,
    },
    {
        value: 'PHONE_CALL',
        icon: PhoneIcon,
    },
    {
        value: 'NOTE',
        icon: NotepadTextIcon,
    },
];

export const NoteTypeSelector = ({ value, onChange }: NoteTypeSelectorProps) => {
    const { t } = useLocale();

    const handleValueChange = (value: string) => {
        onChange(value as CrmNoteType);
    };

    return (
        <RadioGroup value={value} onValueChange={handleValueChange}>
            {noteTypeOptions.map((option) => {
                return (
                    <RadioGroupItem
                        id="option-one"
                        value={option.value}
                        key={option.value}
                        icon={option.icon}
                    >
                        {getNoteTypeLabel(option.value, t)}
                    </RadioGroupItem>
                );
            })}
        </RadioGroup>
    );
};
